import React, { useRef, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Skeleton, Modal, Grid, List, Empty, message } from 'antd';
import { IMAGES, UPLOADS, FILES } from '../../../../params';
import { Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination, Navigation, Autoplay } from 'swiper';
import { IoIosArrowDown } from "react-icons/io";
import 'swiper/swiper.min.css';
import "swiper/components/pagination/pagination.min.css";
import 'swiper/components/navigation/navigation.min.css';
SwiperCore.use([Autoplay, Navigation, Pagination]);

const { useBreakpoint } = Grid;

export const Item = props => {
    const dispatch = useDispatch();

    const screens = useBreakpoint();
    const app_global = useSelector(state => state.app_global);

    const video_01 = useRef(null);
    const [video_01_status, setVideo_01_status] = useState(false);
    const [activeModal, setActiveModal] = useState("");

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

            component_start();
        }
    }, []);

    async function component_start() {        
        
    }

    async function video_01_status_change() {
        if (video_01?.current?.paused) { 
            video_01?.current?.play()
            setVideo_01_status(true);
        } else {
            video_01?.current?.pause();
            setVideo_01_status(false);
        }
    }
    
    return (
        <>
            <Modal mask centered className="modal_portal" key="m1" width={1600} title="Идеальное меню на неделю" open={activeModal === 'perfectMenu'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                <div className='header'>
                    <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                    </svg>
                    <h2>Идеальное меню на неделю</h2>
                </div>
                <div className='text_content'>
                    <p>Мы подготовили для Вас пример идеального меню на неделю. Этот пример не только соблюдает баланс питательных веществ, но также включает разнообразные продукты, богатые витаминами и минералами. Это поможет укрепить иммунную систему, улучшить пищеварение, повысить уровень энергии и снизить риск развития различных заболеваний. Однако, важно помнить, что каждый человек уникален и может требовать индивидуального подхода к питанию, основанного на его потребностях и особенностях организма.</p>
                </div>
                <div className='list_perfect_menu'>
                    <div className='item'>
                        <p className='title'>Понедельник</p>
                        <div className='list'>
                            <div className='list_item'>
                                <p className='name'>Завтрак</p>
                                <p className='text'>Омлет с овощами и тост из цельнозернового хлеба</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Обед</p>
                                <p className='text'>Тушеная говядина с овощами и кукурузным хлебом</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Ужин</p>
                                <p className='text'>Тунец на гриле с овощами и кускусом</p>
                            </div>
                        </div>
                    </div>
                    <div className='item'>
                        <p className='title'>Вторник</p>
                        <div className='list'>
                            <div className='list_item'>
                                <p className='name'>Завтрак</p>
                                <p className='text'>Йогурт с мюсли и свежими фруктами</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Обед</p>
                                <p className='text'>Куриная грудка с овощами и картофелем на пару</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Ужин</p>
                                <p className='text'>Жареный лосось с овощами и рисом</p>
                            </div>
                        </div>
                    </div>
                    <div className='item'>
                        <p className='title'>Среда</p>
                        <div className='list'>
                            <div className='list_item'>
                                <p className='name'>Завтрак</p>
                                <p className='text'>Овсянка с фруктами и орехами</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Обед</p>
                                <p className='text'>Томатный суп с говядиной и овощами и хлебом</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Ужин</p>
                                <p className='text'>Куриные котлеты с овощами и картофельным пюре</p>
                            </div>
                        </div>
                    </div>
                    <div className='item'>
                        <p className='title'>Четверг</p>
                        <div className='list'>
                            <div className='list_item'>
                                <p className='name'>Завтрак</p>
                                <p className='text'>Яичница с помидорами и тостом из цельнозернового хлеба</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Обед</p>
                                <p className='text'>Овощной салат с тунцом и хлебом</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Ужин</p>
                                <p className='text'>Жареная свинина с овощами и картофелем</p>
                            </div>
                        </div>
                    </div>
                    <div className='item'>
                        <p className='title'>Пятница</p>
                        <div className='list'>
                            <div className='list_item'>
                                <p className='name'>Завтрак</p>
                                <p className='text'>Тост из цельнозернового хлеба с авокадо и яйцом</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Обед</p>
                                <p className='text'>Куриные наггетсы с овощами и картофелем на пару</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Ужин</p>
                                <p className='text'>Рыбный суп с овощами и хлебом</p>
                            </div>
                        </div>
                    </div>
                    <div className='item'>
                        <p className='title'>Суббота</p>
                        <div className='list'>
                            <div className='list_item'>
                                <p className='name'>Завтрак</p>
                                <p className='text'>Йогурт с медом и орехами</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Обед</p>
                                <p className='text'>Паста с томатным соусом и свежими овощами</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Ужин</p>
                                <p className='text'>Куриный шашлык с овощами на гриле</p>
                            </div>
                        </div>
                    </div>
                    <div className='item'>
                        <p className='title'>Воскресенье</p>
                        <div className='list'>
                            <div className='list_item'>
                                <p className='name'>Завтрак</p>
                                <p className='text'>Омлет с сыром и овощами и тост из цельнозернового хлеба</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Обед</p>
                                <p className='text'>Говяжья лазанья с овощами</p>
                            </div>
                            <div className='list_item'>
                                <p className='name'>Ужин</p>
                                <p className='text'>Жареная креветка с овощами и кускусом</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='text_content'>
                    <p>Кроме того, можно добавлять перекусы между основными приемами пищи, например, фрукты, орехи, овощи, йогурт и другие здоровые продукты. Важно следить за умеренным употреблением соли, сахара и жиров, а также пить достаточно воды.</p>
                </div>
                <div className="fcenter">
                    <a href={`${FILES}/pdf/perfect_menu.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                </div>
            </Modal>
            <Modal mask centered className="modal_portal" key="m2" width={1600} title="Блюда на завтрак" open={activeModal === 'breakfast'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                <div className='header'>
                    <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                    </svg>
                    <h2>Блюда на завтрак</h2>
                </div>
                <div className='text_content'>
                    <p>Мы подготовили для Вас перечень полезных завтраков, которые помогут обеспечить организм энергией и необходимыми питательными элементами на начало дня. Завтрак – это самый важный прием пищи, который обеспечивает организм необходимой энергией и питательными веществами.</p>
                </div>
                <div className='list_diet'>
                    <List itemLayout="vertical"
                        size="large"
                        pagination={{
                            pageSize: 15,
                            hideOnSinglePage: true,
                            showSizeChanger: false,
                        }}
                        locale={{
                            emptyText: 
                                <Empty 
                                    description="Список пуст"
                                />
                        }}
                        dataSource={
                            [
                                {
                                    title: 'Омлет с овощами и тост из цельнозернового хлеба',
                                    kbju: {
                                        k: '~ 350-400 ккал',
                                        b: '20-25 г',
                                        j: '15-20 г',
                                        u: '25-30 г'
                                    }
                                },{
                                    title: 'Йогурт с мюсли и свежими фруктами',
                                    kbju: {
                                        k: '~ 250-300 ккал',
                                        b: '10-15 г',
                                        j: '5-10 г',
                                        u: '40-50 г'
                                    }
                                },{
                                    title: 'Овсянка с фруктами и орехами',
                                    kbju: {
                                        k: '~ 300-350 ккал',
                                        b: '10-15 г',
                                        j: '10-15 г',
                                        u: '45-50 г'
                                    }
                                },{
                                    title: 'Яичница с помидорами и тостом из цельнозернового хлеба',
                                    kbju: {
                                        k: '~ 300-350 ккал',
                                        b: '15-20 г',
                                        j: '10-15 г',
                                        u: '25-30 г'
                                    }
                                },{
                                    title: 'Тост из цельнозернового хлеба с авокадо и яйцом',
                                    kbju: {
                                        k: '~ 250-300 ккал',
                                        b: '10-15 г',
                                        j: '10-15 г',
                                        u: '25-30 г'
                                    }
                                },{
                                    title: 'Гречневая каша с яйцом и зеленью',
                                    kbju: {
                                        k: '~ 300-350 ккал',
                                        b: '15-20 г',
                                        j: '10-15 г',
                                        u: '30-35 г'
                                    }
                                },{
                                    title: 'Блинчики из овсянки с ягодами и йогуртом',
                                    kbju: {
                                        k: '~ 300-350 ккал',
                                        b: '10-15 г',
                                        j: '10-15 г',
                                        u: '45-50 г'
                                    }
                                },{
                                    title: 'Омлет с лососем и зеленью',
                                    kbju: {
                                        k: '~ 400-450 ккал',
                                        b: '25-30 г',
                                        j: '20-25 г',
                                        u: '10-15 г'
                                    }
                                },{
                                    title: 'Бутерброд с авокадо, куриным филе и помидором',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '28 г',
                                        j: '18 г',
                                        u: '35 г'
                                    }
                                },{
                                    title: 'Каша из риса с медом и орехами',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '7 г',
                                        j: '9 г',
                                        u: '63 г'
                                    }
                                },{
                                    title: 'Гречневая каша с творогом и ягодами',
                                    kbju: {
                                        k: '~ 300 ккал',
                                        b: '16 г',
                                        j: '5 г',
                                        u: '50 г'
                                    }
                                },{
                                    title: 'Блинчики с бананом и орехами',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '11 г',
                                        j: '17 г',
                                        u: '54 г'
                                    }
                                },{
                                    title: 'Салат из тунца, яйца и овощей',
                                    kbju: {
                                        k: '~ 250 ккал',
                                        b: '24 г',
                                        j: '14 г',
                                        u: '7 г'
                                    }
                                },{
                                    title: 'Сырники с ягодным соусом',
                                    kbju: {
                                        k: '~ 300 ккал',
                                        b: '19 г',
                                        j: '11 г',
                                        u: '31 г'
                                    }
                                },{
                                    title: 'Омлет с грибами и зеленью',
                                    kbju: {
                                        k: '~ 200 ккал',
                                        b: '13 г',
                                        j: '14 г',
                                        u: '4 г'
                                    }
                                },{
                                    title: 'Хлебцы с сыром, яйцом и овощами',
                                    kbju: {
                                        k: '~ 250 ккал',
                                        b: '15 г',
                                        j: '10 г',
                                        u: '26 г'
                                    }
                                },{
                                    title: 'Шпинатный омлет с тостом из цельнозернового хлеба',
                                    kbju: {
                                        k: '~ 300 ккал',
                                        b: '16 г',
                                        j: '12 г',
                                        u: '25 г'
                                    }
                                },{
                                    title: 'Яичница с лососем и овощами',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '23 г',
                                        j: '24 г',
                                        u: '7 г'
                                    }
                                },{
                                    title: 'Бутерброд с сыром, авокадо и помидором',
                                    kbju: {
                                        k: '~ 320 ккал',
                                        b: '13 г',
                                        j: '18 г',
                                        u: '26 г'
                                    }
                                },{
                                    title: 'Каша из овсянки с медом и орехами',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '9 г',
                                        j: '13 г',
                                        u: '54 г'
                                    }
                                },{
                                    title: 'Омлет с куриным филе и овощами',
                                    kbju: {
                                        k: '~ 300 ккал',
                                        b: '24 г',
                                        j: '18 г',
                                        u: '7 г'
                                    }
                                },{
                                    title: 'Гречневая каша с творогом и фруктами',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '24 г',
                                        j: '10 г',
                                        u: '56 г'
                                    }
                                },{
                                    title: 'Тост из цельнозернового хлеба с яйцом и зеленью',
                                    kbju: {
                                        k: '~ 250 ккал',
                                        b: '15 г',
                                        j: '12 г',
                                        u: '20 г'
                                    }
                                },{
                                    title: 'Блинчики с яблоками и корицей',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '9 г',
                                        j: '14 г',
                                        u: '46 г'
                                    }
                                },{
                                    title: 'Салат из яиц, тунца и овощей',
                                    kbju: {
                                        k: '~ 300 ккал',
                                        b: '24 г',
                                        j: '20 г',
                                        u: '6 г'
                                    }
                                },{
                                    title: 'Сырники с ягодами и йогуртом',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '16 г',
                                        j: '10 г',
                                        u: '52 г'
                                    }
                                },{
                                    title: 'Омлет с шпинатом и фетой',
                                    kbju: {
                                        k: '~ 300 ккал',
                                        b: '25 г',
                                        j: '20 г',
                                        u: '3 г'
                                    }
                                },{
                                    title: 'Тост с помидорами, маслом и базиликом',
                                    kbju: {
                                        k: '~ 150 ккал',
                                        b: '3 г',
                                        j: '8 г',
                                        u: '15 г'
                                    }
                                },{
                                    title: 'Блины с куриным филе и овощами',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '20 г',
                                        j: '15 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Салат с ягодами, орехами и куриным филе',
                                    kbju: {
                                        k: '~ 300 ккал',
                                        b: '25 г',
                                        j: '15 г',
                                        u: '15 г'
                                    }
                                }
                            ]
                        }
                        renderItem={(item, index) => (
                            <List.Item key={index} >
                                <p className='title'>{item.title}</p>
                                <div className='list'>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.k}</p>
                                        <p className='text'>калорийность</p>
                                    </div>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.b}</p>
                                        <p className='text'>белки</p>
                                    </div>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.j}</p>
                                        <p className='text'>жиры</p>
                                    </div>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.u}</p>
                                        <p className='text'>углеводы</p>
                                    </div>
                                </div>
                            </List.Item>
                        )}
                    />
                </div>
                <div className="fcenter">
                    <a href={`${FILES}/pdf/breakfast.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                </div>
            </Modal>
            <Modal mask centered className="modal_portal" key="m3" width={1600} title="Блюда на обед" open={activeModal === 'lunch'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                <div className='header'>
                    <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                    </svg>
                    <h2>Блюда на обед</h2>
                </div>
                <div className='text_content'>
                    <p>Мы подготовили для Вас перечень полезных обедов, состоящий из 21 блюда. Правильно подобранный обед может обеспечить организм необходимыми питательными веществами и энергией на вторую половину дня, повысить работоспособность и улучшить общее состояние здоровья.</p>
                </div>
                <div className='list_diet'>
                    <List itemLayout="vertical"
                        size="large"
                        pagination={{
                            pageSize: 15,
                            hideOnSinglePage: true,
                            showSizeChanger: false,
                        }}
                        locale={{
                            emptyText: 
                                <Empty 
                                    description="Список пуст"
                                />
                        }}
                        dataSource={
                            [
                                {
                                    title: 'Гречневая каша с овощами + салат из свежих овощей',
                                    kbju: {
                                        k: '~ 450 ккал',
                                        b: '18 г',
                                        j: '15 г',
                                        u: '70 г'
                                    }
                                },{
                                    title: 'Томатный суп с рисом + рыбный рулет с овощами',
                                    kbju: {
                                        k: '~ 450 ккал',
                                        b: '21 г',
                                        j: '10 г',
                                        u: '60 г'
                                    }
                                },{
                                    title: 'Куриная грудка на пару + овощное рагу + греческий салат',
                                    kbju: {
                                        k: '~ 450 ккал',
                                        b: '133 г',
                                        j: '17 г',
                                        u: '33 г'
                                    }
                                },{
                                    title: 'Шашлык из свинины с овощами на гриле +микс салат с оливковым маслом',
                                    kbju: {
                                        k: '~ 330 ккал',
                                        b: '22 г',
                                        j: '21 г',
                                        u: '14 г'
                                    }
                                },{
                                    title: 'Греческий суп с фетой + овощные котлеты',
                                    kbju: {
                                        k: '~ 450 ккал',
                                        b: '18 г',
                                        j: '20 г',
                                        u: '45 г'
                                    }
                                },{
                                    title: 'Рисовая лапша с овощами и куриным филе + салат из капусты с морковью',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '21 г',
                                        j: '10 г',
                                        u: '62 г'
                                    }
                                },{
                                    title: 'Салат с морепродуктами + овощной тушенный пирог',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '23 г',
                                        j: '15 г',
                                        u: '40 г'
                                    }
                                },{
                                    title: 'Фаршированный перец с овощами + микс салат с оливками и лимонным соусом',
                                    kbju: {
                                        k: '~ 320 ккал',
                                        b: '14 г',
                                        j: '16 г',
                                        u: '34 г'
                                    }
                                },{
                                    title: 'Рыбный суп с овощами + запеченный лосось с овощами',
                                    kbju: {
                                        k: '~ 500 ккал',
                                        b: '25 г',
                                        j: '20 г',
                                        u: '35 г'
                                    }
                                },{
                                    title: 'Паста с куриным филе и грибами + свежий овощной салат',
                                    kbju: {
                                        k: '~ 470 ккал',
                                        b: '28 г',
                                        j: '20 г',
                                        u: '55 г'
                                    }
                                },{
                                    title: 'Куриный бульон с рисом  + запеченный куриный филе с овощами',
                                    kbju: {
                                        k: '~ 450 ккал',
                                        b: '35 г',
                                        j: '13 г',
                                        u: '40 г'
                                    }
                                },{
                                    title: 'Ризотто с грибами и шпинатом + салат из овощей с оливковым маслом',
                                    kbju: {
                                        k: '~ 420 ккал',
                                        b: '12 г',
                                        j: '21 г',
                                        u: '54 г'
                                    }
                                },{
                                    title: 'Греческий йогурт с фруктами и орехами + овсянка с ягодами',
                                    kbju: {
                                        k: '~ 450 ккал',
                                        b: '23 г',
                                        j: '15 г',
                                        u: '55 г'
                                    }
                                },{
                                    title: 'Тунец на гриле с овощами + зеленый салат с лимонно- оливковым маслом',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '26 г',
                                        j: '20 г',
                                        u: '12 г'
                                    }
                                },{
                                    title: 'Омлет с овощами и сыром + свежие овощи с хумусом',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '23 г',
                                        j: '25 г',
                                        u: '20 г'
                                    }
                                },{
                                    title: 'Картофельное пюре с запеченным куриным филе + свежий овощной салат',
                                    kbju: {
                                        k: '~ 420 ккал',
                                        b: '33 г',
                                        j: '15 г',
                                        u: '45 г'
                                    }
                                },{
                                    title: 'Куриная грудка на гриле с овощами + свежий овощной салат с оливковым маслом',
                                    kbju: {
                                        k: '~ 370 ккал',
                                        b: '28 г',
                                        j: '15 г',
                                        u: '25 г'
                                    }
                                },{
                                    title: 'Лосось на пару с овощами + зеленый салат с лимонно- оливковым маслом',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '26 г',
                                        j: '20 г',
                                        u: '12 г'
                                    }
                                },{
                                    title: 'Куриный суп с овощами + салат из свежих овощей с оливковым маслом',
                                    kbju: {
                                        k: '~ 220 ккал',
                                        b: '13 г',
                                        j: '8 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Фаршированный перец с рисом и овощами + свежий овощной салат',
                                    kbju: {
                                        k: '~ 420 ккал',
                                        b: '13 г',
                                        j: '20 г',
                                        u: '60 г'
                                    }
                                },{
                                    title: 'Печеный картофель с куриным филе + свежий овощной салат с оливковым маслом',
                                    kbju: {
                                        k: '~ 470 ккал',
                                        b: '33 г',
                                        j: '15 г',
                                        u: '50 г'
                                    }
                                }
                            ]
                        }
                        renderItem={(item, index) => (
                            <List.Item key={index} >
                                <p className='title'>{item.title}</p>
                                <div className='list'>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.k}</p>
                                        <p className='text'>калорийность</p>
                                    </div>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.b}</p>
                                        <p className='text'>белки</p>
                                    </div>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.j}</p>
                                        <p className='text'>жиры</p>
                                    </div>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.u}</p>
                                        <p className='text'>углеводы</p>
                                    </div>
                                </div>
                            </List.Item>
                        )}
                    />
                </div>
                <div className="fcenter">
                    <a href={`${FILES}/pdf/lunch.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                </div>
            </Modal>
            <Modal mask centered className="modal_portal" key="m4" width={1600} title="Блюда на ужин" open={activeModal === 'dinner'} onOk={() => setActiveModal('')} onCancel={() => setActiveModal('')} footer={null}>
                <div className='header'>
                    <svg width="140" height="23" viewBox="0 0 140 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20.824 23L20.76 12.792L15.896 20.984H12.568L7.704 13.144V23H0.824V0.599998H7.032L14.328 12.536L21.432 0.599998H27.64L27.704 23H20.824ZM49.9793 17.304V23H31.3553V0.599998H49.5633V6.296H38.7793V8.92H48.2513V14.36H38.7793V17.304H49.9793ZM52.8865 0.599998H63.9265C66.4225 0.599998 68.6198 1.05867 70.5185 1.976C72.4385 2.872 73.9212 4.16267 74.9665 5.848C76.0332 7.53333 76.5665 9.51733 76.5665 11.8C76.5665 14.0827 76.0332 16.0667 74.9665 17.752C73.9212 19.4373 72.4385 20.7387 70.5185 21.656C68.6198 22.552 66.4225 23 63.9265 23H52.8865V0.599998ZM63.6065 17.112C65.2278 17.112 66.5185 16.6533 67.4785 15.736C68.4598 14.7973 68.9505 13.4853 68.9505 11.8C68.9505 10.1147 68.4598 8.81333 67.4785 7.896C66.5185 6.95733 65.2278 6.488 63.6065 6.488H60.4385V17.112H63.6065ZM78.94 11.032H88.54V16.472H78.94V11.032ZM113.873 0.599998V23H107.665L99.1528 12.824V23H91.7928V0.599998H98.0008L106.513 10.776V0.599998H113.873ZM139.592 0.599998V23H133.384L124.872 12.824V23H117.512V0.599998H123.72L132.232 10.776V0.599998H139.592Z" fill="#487CAB"/>
                    </svg>
                    <h2>Блюда на ужин</h2>
                </div>
                <div className='text_content'>
                    <p>Мы подготовили для Вас перечень полезных ужинов, состоящих из 33 блюд.Правильно подобранный ужин может помочь организму расслабиться и подготовиться к отдыху, а также обеспечить необходимыми питательными веществами для регенерации тканей и восстановления сил.</p>
                </div>
                <div className='list_diet'>
                    <List itemLayout="vertical"
                        size="large"
                        pagination={{
                            pageSize: 15,
                            hideOnSinglePage: true,
                            showSizeChanger: false,
                        }}
                        locale={{
                            emptyText: 
                                <Empty 
                                    description="Список пуст"
                                />
                        }}
                        dataSource={
                            [
                                {
                                    title: 'Курица гриль + овощи на гриле',
                                    kbju: {
                                        k: '~ 300 ккал',
                                        b: '40 г',
                                        j: '10 г',
                                        u: '12 г'
                                    }
                                },{
                                    title: 'Салат Цезарь + крем-суп из грибов',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '15 г',
                                        j: '28 г',
                                        u: '25 г'
                                    }
                                },{
                                    title: 'Телятина стейк + запеченная картошка',
                                    kbju: {
                                        k: '~ 450 ккал',
                                        b: '30 г',
                                        j: '20 г',
                                        u: '35 г'
                                    }
                                },{
                                    title: 'Рыба запеченная + овощи тушеные',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '20 г',
                                        j: '15 г',
                                        u: '20 г'
                                    }
                                },{
                                    title: 'Креветки гриль + зеленый салат',
                                    kbju: {
                                        k: '~ 250 ккал',
                                        b: '35 г',
                                        j: '8 г',
                                        u: '10 г'
                                    }
                                },{
                                    title: 'Говядина гриль + кускус',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '30 г',
                                        j: '15 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Салат с тунцом + суп с говядиной',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '20 г',
                                        j: '10 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Стейк из лосося + запеченная цветная капуста',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '35 г',
                                        j: '20 г',
                                        u: '20 г'
                                    }
                                },{
                                    title: 'Курица тайская + овощи на пару',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '30 г',
                                        j: '15 г',
                                        u: '25 г'
                                    }
                                },{
                                    title: 'Греческий салат + куриный бульон',
                                    kbju: {
                                        k: '~ 300 ккал',
                                        b: '20 г',
                                        j: '10 г',
                                        u: '25 г'
                                    }
                                },{
                                    title: 'Бифштекс с овощами на гриле + запеченный батат',
                                    kbju: {
                                        k: '~ 450 ккал',
                                        b: '35 г',
                                        j: '20 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Печеный кролик + салат из свежих овощей',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '30 г',
                                        j: '15 г',
                                        u: '20 г'
                                    }
                                },{
                                    title: 'Салат Греческий + зеленый горошковый суп',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '20 г',
                                        j: '15 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Свиные ребрышки + запеченные овощи',
                                    kbju: {
                                        k: '~ 500 ккал',
                                        b: '25 г',
                                        j: '30 г',
                                        u: '25 г'
                                    }
                                },{
                                    title: 'Салат с тунцом + овощной суп',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '20 г',
                                        j: '10 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Курица с овощами на воке + кокосовый суп',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '30 г',
                                        j: '30 г',
                                        u: '25 г'
                                    }
                                },{
                                    title: 'Стейк из индейки + овощной рататуй',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '30 г',
                                        j: '10 г',
                                        u: '25 г'
                                    }
                                },{
                                    title: 'Печеный лосось + кускус с овощами',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '35 г',
                                        j: '35 г',
                                        u: '20 г'
                                    }
                                },{
                                    title: 'Салат Цезарь + грибной крем-суп',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '15 г',
                                        j: '28 г',
                                        u: '25 г'
                                    }
                                },{
                                    title: 'Телятина в сливочном соусе + запеченная тыква',
                                    kbju: {
                                        k: '~ 450 ккал',
                                        b: '15 г',
                                        j: '28 г',
                                        u: '35 г'
                                    }
                                },{
                                    title: 'Лазанья + овощной салат',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '30 г',
                                        j: '20 г',
                                        u: '40 г'
                                    }
                                },{
                                    title: 'Суп с мясными фрикадельками + салат из свежих овощей',
                                    kbju: {
                                        k: '~ 500 ккал',
                                        b: '20 г',
                                        j: '15 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Куриная грудка в сливочном соусе + овощи на пару',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '30 г',
                                        j: '25 г',
                                        u: '15 г'
                                    }
                                },{
                                    title: 'Салат с ростбифом + гороховый крем-суп',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '25 г',
                                        j: '20 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Стейк из говядины + рататуй',
                                    kbju: {
                                        k: '~ 500 ккал',
                                        b: '35 г',
                                        j: '25 г',
                                        u: '20 г'
                                    }
                                },{
                                    title: 'Суп с фасолью и курицей + греческий салат',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '25 г',
                                        j: '15 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Салат с креветками + грибной крем-суп',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '20 г',
                                        j: '20 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Стейк из тунца + овощи на гриле',
                                    kbju: {
                                        k: '~ 350 ккал',
                                        b: '25 г',
                                        j: '15 г',
                                        u: '20 г'
                                    }
                                },{
                                    title: 'Салат с курицей и авокадо + зеленый гороховый суп',
                                    kbju: {
                                        k: '~ 400 ккал',
                                        b: '25 г',
                                        j: '20 г',
                                        u: '30 г'
                                    }
                                },{
                                    title: 'Свиные котлеты + запеченный картофель',
                                    kbju: {
                                        k: '~ 450 ккал',
                                        b: '30 г',
                                        j: '25 г',
                                        u: '20 г'
                                    }
                                }
                            ]
                        }
                        renderItem={(item, index) => (
                            <List.Item key={index} >
                                <p className='title'>{item.title}</p>
                                <div className='list'>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.k}</p>
                                        <p className='text'>калорийность</p>
                                    </div>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.b}</p>
                                        <p className='text'>белки</p>
                                    </div>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.j}</p>
                                        <p className='text'>жиры</p>
                                    </div>
                                    <div className='list_item'>
                                        <p className='name'>{item.kbju.u}</p>
                                        <p className='text'>углеводы</p>
                                    </div>
                                </div>
                            </List.Item>
                        )}
                    />
                </div>
                <div className="fcenter">
                    <a href={`${FILES}/pdf/dinner.pdf`} target='_blank' className={`ant-btn ant-btn-primary default button_more`}><span>Скачать файл</span></a>
                </div>
            </Modal>
            <section className='container_full --hls_item_1'>
                <section className='top'>
                    <section className='container shadow default_padding'>
                        <h1>Сбалансируйте свой рацион</h1>
                    </section>
                </section>
                <section className='body'>
                    <section className='container shadow default_padding'>
                        <div className='content left'>
                            {app_global.loading ?
                                <Skeleton active />
                            :
                                <>
                                    <div className='header'>
                                        <div className='posts_image_big'>
                                            <img src={`${IMAGES}/banners/hls_image_01_01_01.jpeg`} />
                                        </div>
                                    </div>
                                    <div className='body'>
                                        <div className='text_content'>
                                            <h2>Сбалансируйте свой рацион</h2>
                                            <ol>
                                                <li><none />Употребляйте разнообразную пищу. Старайтесь включать в свой рацион продукты разных групп: овощи, фрукты, злаки, бобовые, мясо, рыбу, яйца и т.д. Это поможет вам получать все необходимые  питательные элементы</li>
                                                <li><none />Перед употреблением продуктов посмотрите на их пищевую ценность. Например, многие фрукты богаты витамином С, овощи - витамином А, кальцием и железом, а мясо и рыба являются отличными источниками белка и железа. Таким образом, вы можете убедиться, что ваш рацион включает все необходимые питательныеэлементы</li>
                                                <li><none />Избегайте излишнего потребления ненужных питательных веществ, таких как сахар и соль. Например, слишком большое потребление сахара может привести к ожирению, а избыток соли может повысить давление и вызвать проблемы с сердцем</li>
                                                <li><none />Помните о правильных пропорциях. Например, вам не нужно употреблять большое количество жиров или углеводов, если вы не занимаетесь тяжелой физической работой. В таком случае, вам может потребоваться больше белка, чтобы поддерживать мышечную массу</li>
                                                <li><none />Избегайте голодания и переедания. Организму нужна определенная калорийность, чтобы правильно функционировать. Голодание или переедание может привести к проблемам со здоровьем и даже к нарушению метаболизма</li>
                                            </ol>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        <div className='content right'>
                            {app_global.loading ?
                                <Skeleton active />
                            :
                                <>
                                    <div className='body'>
                                        <div className='list_item'>
                                            <div className='visible'>
                                                <img className='banner' src={`${IMAGES}/banners/hls_image_01_01_02.jpg`} />
                                                <div className='right_info'>
                                                    <div className='info'>
                                                        <div className='title'>Узнай свой индекс массы тела</div>
                                                        <div className='description'>Онлайн калькулятор индекса массы тела помогает оценить соотношение вашего веса и роста</div>
                                                    </div>
                                                    <Link to={`/calculators/1`} exact={ true } onClick={() => scroll.scrollToTop()} className={`ant-btn ant-btn-primary default button_more`}><span>Рассчитать</span></Link>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`custom_video ${video_01_status ? 'play' : 'pause'}`} onClick={video_01_status_change}>
                                            <video ref={video_01} id="video_01" preload="auto" poster={`${IMAGES}/banners/hls_image_01_01_04.jpg`} loop>
                                                <source id='mp4' src={`${IMAGES}/banners/hls_video_01_01_01_2.mp4`} type='video/mp4' />
                                            </video>
                                        </div>
                                        <div className='list_item'>
                                            <div className='visible'>
                                                <img className='banner' src={`${IMAGES}/banners/hls_image_01_01_03.jpg`} />
                                                <div className='right_info'>
                                                    <div className='info'>
                                                        <div className='title'>Идеальное меню на неделю</div>
                                                        <div className='description'>В меню соблюдается баланс питательных веществ, а так же включены продукты, богатые витаминами и минералами</div>
                                                    </div>
                                                    <div onClick={() => setActiveModal('perfectMenu')} className={`ant-btn ant-btn-primary default button_more`}><span>Посмотреть</span></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                    </section>
                    <section className='container shadow default_padding next'>
                        <div className='next_container'>
                            <div className='content full'>
                                <div className='list visible'>
                                    <div className='item breakfast'>
                                        <div className='rotate'>
                                            <p>Блюда на завтрак</p>
                                        </div>
                                    </div>
                                    <div className='item lunch'>
                                        <div className='rotate'>
                                            <p>Блюда на обед</p>
                                        </div>
                                    </div>
                                    <div className='item dinner'>
                                        <div className='rotate'>
                                            <p>Блюда на ужин</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='list hidden'>
                                    <div className='item breakfast' onClick={() => setActiveModal('breakfast')}>
                                        <div className='rotate'>
                                            <img src={`${IMAGES}/banners/hls_image_01_01_05.png`} />
                                        </div>
                                    </div>
                                    <div className='item lunch' onClick={() => setActiveModal('lunch')}>
                                        <div className='rotate'>
                                            <img src={`${IMAGES}/banners/hls_image_01_01_06.png`} />
                                        </div>
                                    </div>
                                    <div className='item dinner' onClick={() => setActiveModal('dinner')}>
                                        <div className='rotate'>
                                            <img src={`${IMAGES}/banners/hls_image_01_01_07.png`} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </section>
            </section>
        </>
    );
};